import { Component, Input, inject } from '@angular/core';
import { Comment } from '../../services/firebase.model';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { FirebaseFirestoreService } from '../../services/firebase-firestore.service';
import { firstValueFrom } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { DatePipe, JsonPipe } from '@angular/common';

@Component({
  selector: 'app-comments-dialog',
  standalone: true,
  imports: [
    InputTextareaModule,
    ButtonModule,
    FormsModule,
    DatePipe
  ],
  templateUrl: './comments-dialog.component.html',
  styleUrl: './comments-dialog.component.scss'
})
export class CommentsDialogComponent {
  firestoreService = inject(FirebaseFirestoreService)
  dialogConfigRef = inject(DynamicDialogConfig<CommentsDialogComponent>)

  comments: Comment[] | undefined = this.dialogConfigRef.data?.comments.map((x:Comment) => ({
    ...x,
    created: new Date(x.created)
  }))
  renderId: string = this.dialogConfigRef.data?.renderId

  comment: string = ""

  async addComment() {
    const comment: Comment = await this.firestoreService.addGroupComment(
      this.renderId,
      this.comment
    )
    this.comments = [...(this.comments || []), comment]
    this.comment = ""
  }
}
